import { deviceService } from "../../services/deviceService";
import { fetchUtil } from "../../helpers/fetchUtil";
import AuthService from "../../services/AuthService";
import Config from "../../Config";

export const ADD_DEVICE_REQUEST = "ADD_DEVICE_REQUEST";
export const ADD_DEVICE_FAIL = "ADD_DEVICE_FAIL";
export const ADD_DEVICE_SUCCESS = "ADD_DEVICE_SUCCESS";

export const GET_DEVICE_REQUEST = "GET_DEVICE_REQUEST";
export const GET_DEVICE_FAIL = "GET_DEVICE_FAIL";
export const GET_DEVICE_SUCCESS = "GET_DEVICE_SUCCESS";

export const DEVICE_LIST_REQUEST = "DEVICE_LIST_REQUEST";
export const DEVICE_LIST_FAIL = "DEVICE_LIST_FAIL";
export const DEVICE_LIST_SUCCESS = "DEVICE_LIST_SUCCESS";

export const EDIT_DEVICE_REQUEST = "EDIT_DEVICE_REQUEST";
export const EDIT_DEVICE_FAIL = "EDIT_DEVICE_FAIL";
export const EDIT_DEVICE_SUCCESS = "EDIT_DEVICE_SUCCESS";
export const FORGET_DEVICE_SUCCESS = "FORGET_DEVICE_SUCCESS";

export const SETUP_DEVICE = "SETUP_DEVICE";

export const SET_CURRENT_STATE_DEVICE = "SET_CURRENT_STATE_DEVICE";
export const SET_SESSION_DATA = "SET_SESSION_DATA";

export const SET_CURRENT_DEVICE = "SET_CURRENT_DEVICE";

export const SET_SESSION_BEGIN = "SET_SESSION_BEGIN";
export const CLEAR_SESSION_DATA = "CLEAR_SESSION_DATA";

export const SET_SMART_PATH_DATA = "SET_SMART_PATH_DATA";

export const SET_INITIAL_SMART_PATH_DATA = "SET_INITIAL_SMART_PATH_DATA";

export const SET_DEVICE_INFORMARION = "SET_DEVICE_INFORMARION";

export const CLEAR_DEVICE_STATE = "CLEAR_DEVICE_STATE";

export const DEVICE_CONNECTED = "DEVICE_CONNECTED";

export const DEVICE_DISCONNECTED = "DEVICE_DISCONNECTED";

export const SET_CURRENT_DEVICE_STATISTIC = "SET_CURRENT_DEVICE_STATISTIC";

export const CONNECTING = "CONNECTING";

export const CONNECTION_ERROR = "CONNECTION_ERROR";

export const SET_SMARTH_PATH_TITLE = "SET_SMARTH_PATH_TITLE";

export const SET_SMARTH_PATH_INDEX = "SET_SMARTH_PATH_INDEX";

export const getDevice = (deviceId) => (dispatch, getState) => {
  dispatch({ type: GET_DEVICE_REQUEST });
  return fetchUtil(`/${deviceId}`, {
    token: getState().userAuth.user.token
  })
    .then((res) => {
      dispatch({ type: GET_DEVICE_SUCCESS, payload: res });
      return Promise.resolve(res);
    })
    .catch((err) => {
      dispatch({ type: GET_DEVICE_FAIL });
      return Promise.reject(err);
    });
};

export const getDevices = (userIdOrToken, tokenOrNull) => (dispatch, getState) => {
  // Log incoming parameters to help diagnose the issue
  console.log('getDevices raw params:', {
    userIdOrToken: typeof userIdOrToken === 'object' ? 'object' : userIdOrToken,
    tokenOrNull: tokenOrNull
  });
  
  dispatch({ type: DEVICE_LIST_REQUEST });
  
  try {
    // Get current state for fallback
    const state = getState();
    
    // Extract userId and token with fallbacks
    // 1. Try to use parameters directly if they're in the expected format
    // 2. Try to extract from userIdOrToken if it might be a user object
    // 3. Finally fall back to Redux state
    let effectiveUserId, effectiveToken;
    
    if (tokenOrNull !== undefined) {
      // Called with both params (token, userId)
      effectiveToken = userIdOrToken;
      effectiveUserId = tokenOrNull;
    } else {
      // Called with just one parameter that might be userId or user object
      // Check if userIdOrToken might be a token (contains Bearer or is long string)
      const isToken = typeof userIdOrToken === 'string' && 
                      (userIdOrToken.includes('Bearer') || userIdOrToken.length > 30);
                      
      if (isToken) {
        effectiveToken = userIdOrToken;
        effectiveUserId = state.userAuth?.user?.id;
      } else if (typeof userIdOrToken === 'object' && userIdOrToken !== null) {
        // Might be a user object
        effectiveUserId = userIdOrToken.id || userIdOrToken.userId;
        effectiveToken = userIdOrToken.token || state.userAuth?.user?.token;
      } else if (userIdOrToken) {
        // Just a userId
        effectiveUserId = userIdOrToken;
        effectiveToken = state.userAuth?.user?.token;
      } else {
        // No parameter provided, try to get from state
        effectiveUserId = state.userAuth?.user?.id;
        effectiveToken = state.userAuth?.user?.token;
      }
    }
    
    // Final fallbacks from Redux state
    if (!effectiveUserId) {
      effectiveUserId = state.userAuth?.user?.id;
    }
    
    if (!effectiveToken) {
      effectiveToken = state.userAuth?.user?.token;
    }
    
    // Log the resolved values
    console.log('getDevices resolved params:', {
      userId: effectiveUserId,
      hasToken: !!effectiveToken
    });
    
    // CRITICAL: Early return if we don't have a valid userId
    // This prevents the 'undefined' in the URL that's causing the error
    if (!AuthService.isValidUserId(effectiveUserId)) {
      console.error('Action getDevices: No valid userId available, cannot fetch devices');
      const error = new Error('No valid userId available to fetch devices');
      dispatch({ type: DEVICE_LIST_FAIL, payload: error });
      return Promise.reject(error);
    }
  
    // Make the API call with the correct parameters
    return fetchUtil(`/${effectiveUserId}/devices`, {
      token: effectiveToken,
      externalApi: false // Critical flag to use the API_URL that includes '/api/DaVinciUsers'
    })
    .then(res => {
      console.log('Action getDevices: Devices fetched successfully:', res);
      dispatch({ type: DEVICE_LIST_SUCCESS, payload: res });
      return res;
    })
    .catch(err => {
      console.error('Action getDevices: Device fetch error:', err);
      dispatch({ type: DEVICE_LIST_FAIL, payload: err });
      return Promise.reject(err);
    });
  } catch (err) {
    // Handle any errors in parameter extraction or processing
    console.error('Action getDevices: Parameter processing error:', err);
    dispatch({ type: DEVICE_LIST_FAIL, payload: err });
    return Promise.reject(err);
  }
};

export const addDevice = (id, bodyData) => (dispatch, getState) => {
  const token = getState().userAuth.user.token;
  return fetchUtil(`/${id}/devices`, {
    method: "POST",
    body: JSON.stringify(bodyData),
    token
  })
    .then((res) => {
      dispatch({ type: ADD_DEVICE_SUCCESS, payload: res });
      return Promise.resolve(res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const editDevice = (id, bodyData, override) => (dispatch, getState) => {
  const token = getState().userAuth.user.token;
  return fetchUtil(`api/Devices/${id}`, {
    method: "PUT",
    body: JSON.stringify(bodyData),
    token,
    externalApi: true
  })
    .then((res) => {
      dispatch({
        type: EDIT_DEVICE_SUCCESS,
        payload: bodyData,
        override: override,
      });
      return Promise.resolve(res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const forgetDevice = (id, bodyData) => (dispatch, getState) => {
  let payload = { ...bodyData, forgotten: true };
  const token = getState().userAuth.user.token;
  return fetchUtil(`/api/Devices/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
    token,
    externalApi: true
  })
    .then((res) => {
      dispatch({ type: FORGET_DEVICE_SUCCESS, payload: res });
      return Promise.resolve(res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
